import {Component, Input, ViewChild} from '@angular/core';
import {AuctionService, DateTimeFormat, DateUtilsService} from 'remarketing-angular-library';
import { ModalComponent, SpinnerComponent } from 'remarketing-ui-components-lib';
import {take} from 'rxjs/operators';
import {TranslocoService} from '@jsverse/transloco';
import {AuctionItemRemovalHistory} from '../../../../sell/lib/manage-inventory/components/removal-history/removal-history.component';
import {Router} from '@angular/router';
import { CurrencyFormatService } from 'smartauction-frontend-micro-library';
import {
  OfferModalsHeaderComponent
} from '../../../ui/comment/modal-actions/offer-header/offer-modals-header.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-posting-history-modal',
    templateUrl: './posting-history-modal.component.html',
    styleUrls: ['./posting-history-modal.component.scss'],
    imports: [ModalComponent, OfferModalsHeaderComponent, SpinnerComponent, CommonModule]
})
export class PostingHistoryModalComponent {
  @ViewChild(ModalComponent) modal: ModalComponent;
  @Input() modalId = 'posting-history-modal';
  @Input() tenantName: string;
  @Input() auctionItemUuid: string;
  public isLoading = true;

  removalHistory: AuctionItemRemovalHistory[];
  isMobile: boolean;

  CONSTANTS = {
    labelTitle: '',
    labelPostedDate: '',
    labelRemovalReason: '',
    labelHits: '',
    labelBidListAdds: '',
    labelPostingPrice: '',
    labelBuyNowPrice: '',
    labelFees: '',
    labelHighestOfferPrice: '',
    labelSeeDetails: '',
    btnClose: ''
  };

  constructor(
    private readonly translocoService: TranslocoService,
    private readonly auctionItemService: AuctionService,
    private readonly router: Router,
    readonly dateUtilService: DateUtilsService,
    private readonly currencyFormatService: CurrencyFormatService
  ) {}

  show() {
    this.isLoading = true;
    this.getTranslations();
    this.getRemovalHistory();
    this.modal.show();
  }

  close() {
    this.modal.close();
  }

  localizeDate(date) {
    return this.dateUtilService.localizeDate(date);
  }

  getRemovalHistory() {
    this.auctionItemService
      .getAuctionItemSellRemovalHistory(this.auctionItemUuid)
      .pipe(take(1))
      .subscribe(history => {
        this.removalHistory = history as AuctionItemRemovalHistory[];
        // Sort by desc dates
        this.removalHistory.sort((a, b) => {
          return Date.parse(b.statusChangedDate) - Date.parse(a.statusChangedDate);
        });
        this.isLoading = false;
      });
  }

  getFormattedRemovedTime(entry: AuctionItemRemovalHistory) {
    return this.dateUtilService.formatDate(entry.statusChangedDate, DateTimeFormat.H_MM_A, true);
  }

  getFormattedPostedDate(entry: AuctionItemRemovalHistory) {
    return this.dateUtilService.formatDate(entry.postedDate);
  }

  seeDetails(i: number) {
    this.close();
    this.router.navigate([`/inventory/${this.removalHistory[i].inventoryItemUuid}/details`]);
  }

  formatDate(date) {
    return this.dateUtilService.localizeDate(date);
  }

  formatCurrency(value) {
    return this.currencyFormatService.formatCurrency(value);
  }

  formatTime(entry: AuctionItemRemovalHistory) {
    return this.dateUtilService.localizeTime(entry.statusChangedDate, true);
  }

  formatDateTime(entry: AuctionItemRemovalHistory) {
    return this.dateUtilService.localizeDateAndTime(entry.statusChangedDate, true);
  }

  getTranslations() {
    const keyParams = {
      'sellModule.manageInventory.removalHistory': {},
      common: {}
    };

    this.translocoService
      .selectTranslateObject(keyParams)
      .pipe(take(1))
      .subscribe(
        (translate: any[]) => {
          this.CONSTANTS.labelTitle = translate[0].textPostingHistory;
          this.CONSTANTS.labelPostedDate = translate[0].textPostedDate;
          this.CONSTANTS.labelRemovalReason = translate[0].textRemovalReason;
          this.CONSTANTS.labelHits = translate[0].textHits;
          this.CONSTANTS.labelBidListAdds = translate[0].textBidListAdds;
          this.CONSTANTS.labelPostingPrice = translate[0].textPostingPrice;
          this.CONSTANTS.labelBuyNowPrice = translate[0].textBuyNowPrice;
          this.CONSTANTS.labelFees = translate[0].textFees;
          this.CONSTANTS.labelHighestOfferPrice = translate[0].textHighestOfferPrice;
          this.CONSTANTS.labelSeeDetails = translate[0].textSeeDetails;
          this.CONSTANTS.btnClose = translate[1].btnClose;
        },
        error => {
          console.log(error);
        }
      );
  }
}
